import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, DatePicker, InputNumber } from "antd";
import "./Form.css";
import InputForm from "./InputForm";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";

import PessoaFrame from './PessoaFrame';
import UsuarioFrame from './UsuarioFrame';
import MunicipioFrame from './MunicipioFrame';
import GrupoFrame from './GrupoFrame';
import ProdutoFrame from './ProdutoFrame';
import TipoAtividadeFrame from './TipoAtividadeFrame';
import LinhaProducaoFrame from './LinhaProducaoFrame';

import axios from "axios";

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Item: ItemForm } = Form;

export const OPCOES_COMBO_TIPO = [
  { key: 'X', label: 'Todos' },
  { key: 'P', label: 'Pedidos' },
  { key: 'O', label: 'Orçamentos' },
  { key: 'B', label: 'Bonificações' },
]

export const OPCOES_COMBO_ATIVIDADES = [
  { key: 'X', label: 'Todas as Atividades' },
  { key: 'E', label: 'Atividades Executadas' },
  { key: 'N', label: 'Atividades Não Executadas' },
]


export default class FiltrosForm extends Component {
  state = {
    registroFiltros: {
      tipoTela: '',
      buscaDataIni: '',
      buscaDataFim: '',
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0' },
      buscaMunicipio: { key: '0' },
      buscaAgruparCidades: 0,
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaOrdem: { campo: '', ordem: '' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaLote: '',
      buscaAtividade: { key: '0' },
      buscaTipoAtiv: { key: 'X' },
      buscaLinhaProducao: { key: '0' },
      buscaPrioridade: { key: '0' },
      buscaStatusProducao: { key: '9999' },
      buscaStatusPedido: { key: '0' },
    },
    statusProducaoSelect: [],
    statusPedidoSelect: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.filtros !== propsAnterior.filtros) {
      this.setState({
        registroFiltros: this.props.filtros,
      }, () => {
        if (this.props.filtros.tipoTela === 'PED') {
          this.buscaStatusPedido();
        }
        if (this.props.filtros.tipoTela === 'MP') {
          this.buscaStatusProducao();
        }
      });
    }
  }


  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
      buscaUsuario: {
        key: getTemPermissao('UsuarioSupervisor', 'cons') ? '0' : usuario.usu_cpf
      },
    }, this.getListaRegistros);
  }



  onOK = () => {
    this.props.onFiltrarClick(this.state.registroFiltros);
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registroFiltros } = this.state;
    registroFiltros[id] = value;
    this.setState({ [id]: value });
  };

  onChangePeriodo = event => {
    const { registroFiltros } = this.state;
    if (event[0]) {
      registroFiltros.buscaDataIni = moment(event[0]._d).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(event[1]._d).format('DD/MM/YYYY');
    } else {
      registroFiltros.buscaDataIni = moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY');
      registroFiltros.buscaDataFim = moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY');
    }
    this.setState({
      registroFiltros
    },
      this.getListaRegistros
    );
  };

  onInputChangeMes = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaMes'] = event;
    this.setState(registroFiltros);
  }

  onInputChangeAno = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaAno'] = event;
    this.setState(registroFiltros);
  }

  onChangePessoa = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaPessoa'] = event.buscaPessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaUsuario'] = event.buscaUsuario;
    this.setState(event);
  }

  onChangeGrupo = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaGrupoProduto'] = event.buscaGrupoProduto;
    this.setState(event);
  }

  onChangeProduto = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaProduto'] = event.buscaProduto;
    this.setState(event);
  }

  onChangeMunicipio = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaMunicipio'] = event.buscaMunicipio;
    this.setState(event);
  }

  onChangeAgruparCidades = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaAgruparCidades'] = event.target.value ? 1 : 0;
    this.setState(event);
  }

  onChangeAtividade = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaAtividade'] = event.buscaAtividade;
    this.setState(event);
  }

  onChangeLinhaProducao = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaLinhaProducao'] = event.buscaLinhaProducao;
    this.setState(event);
  }

  onInputChangePrioridade = event => {
    const value = event;
    const id = 'buscaPrioridade';
    const { registroFiltros } = this.state;
    registroFiltros[id] = value;
    this.setState({
      [id]: value
    });
  }
  onChangeStatusProducao = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaStatusProducao'] = event.buscaStatusProducao;
    this.setState(event);
  }


  buscaStatusProducao = (value) => {
    this.setState({ statusProducaoSelect: [] })
    axios.get('/statusProducao/lista')
      .then(response => {
        const { data } = response;
        const statusProducaoSelect = data.map(regList => {
          return {
            key: regList.sp_idf,
            label: regList.sp_descricao,
          }
        });
        statusProducaoSelect.unshift({ key: '9999', label: 'Somente Status à Produzir', })
        statusProducaoSelect.unshift({ key: '0', label: 'Todos os Status', })
        this.setState({
          statusProducaoSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }


  onChangeStatusPedido = event => {
    const { registroFiltros } = this.state;
    registroFiltros['buscaStatusPedido'] = event.buscaStatusPedido;
    this.setState(event);
  }


  buscaStatusPedido = (value) => {
    this.setState({ statusPedidoSelect: [] })
    axios.get('/statusVenda/lista')
      .then(response => {
        const { data } = response;
        const statusPedidoSelect = data.map(regList => {
          return {
            key: regList.sv_idf,
            label: regList.sv_descricao,
          }
        });
        statusPedidoSelect.unshift({ key: '0', label: 'Todos os Status', })
        this.setState({
          statusPedidoSelect,
        })
      }).catch(error => {
        console.error(error.response);
      })
  }





  render() {
    const { onCancelarFiltroClick, visivel } = this.props;
    const { statusProducaoSelect, statusPedidoSelect } = this.state;
    const { tipoTela, buscaDataIni, buscaDataFim, buscaMes, buscaAno, buscaPessoa, buscaUsuario, buscaMunicipio, buscaAgruparCidades,
      buscaGrupoProduto, buscaProduto, buscaTipo, buscaControle, buscaLote, buscaAtividade, buscaTipoAtiv, buscaLinhaProducao, buscaPrioridade, buscaStatusProducao, buscaStatusPedido
    } = this.state.registroFiltros;

    // console.log('FiltrosForm.this.state: ', this.state);

    return (
      <Modal
        title={"Filtro"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarFiltroClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <Row>
          {tipoTela === 'AP' || tipoTela === 'ATIV' || tipoTela === 'CC' || tipoTela === 'INV' || tipoTela === 'CTASREC' || tipoTela === 'PED' || tipoTela === 'MP' || tipoTela === 'OP' || tipoTela === 'PV' || tipoTela === 'VENGRADE' || tipoTela === 'LOG' || tipoTela === 'ESTPROD' ? (
            <div>
              <Col xs={24} style={{ marginBottom: 30, paddingRight: 20 }}>
                <span>Período</span>
                <RangePicker
                  style={{ width: "100%" }}
                  masker={maskDate}
                  value={[moment(buscaDataIni, dateFormat), moment(buscaDataFim, dateFormat)]}
                  format={dateFormat}
                  onChange={this.onChangePeriodo}
                />
              </Col>
            </div>
          ) : null}

          {tipoTela === 'METAS' ? (
            <Col xs={24} style={{ marginBottom: 30, marginTop: 20 }}>
              <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                <Row>
                  <span>Mês</span>
                </Row>
                <Row>
                  <InputNumber
                    ref="Input"
                    id={buscaMes}
                    value={buscaMes}
                    onChange={this.onInputChangeMes}
                    min={0}
                    max={12}
                    maxLength={2}
                    style={{ width: "100%" }}
                  />
                </Row>
              </Col>
              <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                <Row>
                  <span>Ano</span>
                </Row>
                <Row>
                  <InputNumber
                    ref="Input"
                    id={buscaAno}
                    value={buscaAno}
                    onChange={this.onInputChangeAno}
                    min={2020}
                    max={2100}
                    maxLength={4}
                    style={{ width: "100%" }}
                  />
                </Row>
              </Col>
            </Col>
          ) : null}

          {tipoTela === 'AP' || tipoTela === 'ATIV' || tipoTela === 'CC' || tipoTela === 'CTASREC' || tipoTela === 'PED' || tipoTela === 'MP' || tipoTela === 'OP' || tipoTela === 'PV' || tipoTela === 'VENGRADE' ? (
            < Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <PessoaFrame
                label="Cliente"
                id="buscaPessoa"
                value={buscaPessoa}
                width={"100%"}
                onChange={this.onChangePessoa}
                descricaoPrimeiroItem="Todos os Clientes"
              />
            </Col>
          ) : null}

          {tipoTela === 'ATIV' || tipoTela === 'CC' || tipoTela === 'PED' || tipoTela === 'PV' || tipoTela === 'VENGRADE' || tipoTela === 'METAS' || tipoTela === 'LOG' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <UsuarioFrame
                label="Vendedor"
                id="buscaUsuario"
                value={buscaUsuario}
                todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                width={"100%"}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Todos os Vendedores"
                disabled={this.state.usuario && !getTemPermissao('UsuarioSupervisor', 'cons') ? true : false}
              />
            </Col>
          ) : null}

          {tipoTela === 'AP' || tipoTela === 'ATIV' || tipoTela === 'CC' || tipoTela === 'PED' || tipoTela === 'MP' || tipoTela === 'OP' || tipoTela === 'PV' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <MunicipioFrame
                label="Município"
                id="buscaMunicipio"
                value={buscaMunicipio}
                width={"100%"}
                onChange={this.onChangeMunicipio}
                descricaoPrimeiroItem="Todos os Municípios"
              />
            </Col>
          ) : null}

          {tipoTela === 'CC' ? (
            <Col xs={24} sm={12} style={{ marginTop: 0 }} className="camposEspacoDireita">
              <InputForm
                type="checkbox"
                id="buscaAgruparCidades"
                ref="buscaAgruparCidades"
                value={buscaAgruparCidades}
                onChange={this.onChangeAgruparCidades}
              >
                Agrupar por Cidades
              </InputForm>
            </Col>
          ) : null}

          {tipoTela === 'INV' || tipoTela === 'PV' || tipoTela === 'ESTPROD' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <GrupoFrame
                label="Grupo Produto"
                id="buscaGrupoProduto"
                value={buscaGrupoProduto}
                width={"100%"}
                onChange={this.onChangeGrupo}
                descricaoPrimeiroItem="Todos os Grupos"
              />
            </Col>
          ) : null}

          {tipoTela === 'AP' || tipoTela === 'INV' || tipoTela === 'MP' || tipoTela === 'PV' || tipoTela === 'VENGRADE' || tipoTela === 'ESTPROD' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <ProdutoFrame
                label="Produto"
                id="buscaProduto"
                value={buscaProduto}
                verifica_prod_vend={true}
                width={"100%"}
                onChange={this.onChangeProduto}
                descricaoPrimeiroItem="Todos os Produtos"
              />
            </Col>
          ) : null}

          {tipoTela === 'PED' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Tipo</span>
              <InputForm
                type="select"
                id="buscaTipo"
                ref="buscaTipo"
                value={buscaTipo}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_TIPO}
                validator={value => Boolean(value)}
                style={{ width: "100%", marginBottom: 0, paddingBotton: 0 }}
              />
            </Col>
          ) : null}

          {tipoTela === 'AP' || tipoTela === 'PED' || tipoTela === 'MP' || tipoTela === 'OP' || tipoTela === 'LOG' || tipoTela === 'ESTPROD' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Controle</span>
              <InputForm
                id="buscaControle"
                ref="buscaControle"
                value={buscaControle}
                onChange={this.onChange}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'ESTPROD' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Lote</span>
              <InputForm
                id="buscaLote"
                ref="buscaLote"
                value={buscaLote}
                onChange={this.onChange}
                style={{ width: "100%" }}
              />
            </Col>
          ) : null}

          {tipoTela === 'ATIV' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <TipoAtividadeFrame
                label="Atividade"
                id="buscaAtividade"
                value={buscaAtividade}
                width={"100%"}
                vendedor={1}
                onChange={this.onChangeAtividade}
                descricaoPrimeiroItem="Todas as Atividades"
              />
            </Col>
          ) : null}

          {tipoTela === 'ATIV' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Tipo de Atividade</span>
              <InputForm
                type="select"
                id="buscaTipoAtiv"
                ref="buscaTipoAtiv"
                value={buscaTipoAtiv}
                placeholder="Selecione"
                onChange={this.onChange}
                data={OPCOES_COMBO_ATIVIDADES}
                validator={value => Boolean(value)}
                style={{ width: "100%", marginBottom: 0, paddingBotton: 0 }}
              />
            </Col>
          ) : null}

          {tipoTela === 'MP' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <LinhaProducaoFrame
                label="Linha Produção"
                id="buscaLinhaProducao"
                value={buscaLinhaProducao}
                width={"100%"}
                vendedor={1}
                onChange={this.onChangeLinhaProducao}
                descricaoPrimeiroItem="Todas as Linhas de Produção"
              />
            </Col>
          ) : null}

          {tipoTela === 'MP' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Status Produção</span>
              <InputForm
                type="select"
                id="buscaStatusProducao"
                ref="buscaStatusProducao"
                value={buscaStatusProducao}
                placeholder="Selecione"
                onChange={this.onChange}
                data={statusProducaoSelect}
                validator={value => Boolean(value)}
                style={{ width: "100%", marginBottom: 0, paddingBotton: 0 }}
              />
            </Col>
          ) : null}


          {tipoTela === 'PED' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Status Pedido</span>
              <InputForm
                type="select"
                id="buscaStatusPedido"
                ref="buscaStatusPedido"
                value={buscaStatusPedido}
                placeholder="Selecione"
                onChange={this.onChange}
                data={statusPedidoSelect}
                validator={value => Boolean(value)}
                style={{ width: "100%", marginBottom: 0, paddingBotton: 0 }}
              />
            </Col>
          ) : null}

          {tipoTela === 'MP' ? (
            <Col xs={24} sm={12} style={{ marginTop: -20 }} className="camposEspacoDireita">
              <span>Prioridade</span>
              <InputNumber
                ref="Input"
                id={buscaPrioridade}
                value={buscaPrioridade}
                onChange={this.onInputChangePrioridade}
                min={0}
                max={3}
                maxLength={1}
                style={{ width: '100%' }}
              />
            </Col>
          ) : null}


        </Row>

        <div>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Filtrar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarFiltroClick}
                  className="botoesModalFecharForm"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>


      </Modal >



    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FiltrosForm.js